export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Final2_01.0807fc49.jpg";